// Shared helpers for the Andar Bahar (ab20) / Andar Bahar 2 (abj) reference pages.

// Owl responsive items for the video sliders: { 0: 3, 320: 3, 768: 4 } (viewport width)
export const abOwlItems = () => ((typeof window !== "undefined" ? window.innerWidth : 1920) >= 768 ? 4 : 3);

// Reference `main`: feed `sub` filtered to subtype = game type, ordered by sr
export const abMain = (sub, gameType) =>
  (Array.isArray(sub) ? sub : [])
    .filter((s) => s?.subtype === gameType)
    .sort((a, b) => Number(a?.sr) - Number(b?.sr));

// Andar Bahar 2 (abj) feed `card`: [0] joker, [1] first Bahar card, [2] first Andar card, then from index 3
// odd → Bahar, even → Andar ("1" = not dealt), each reversed for the slider.
export function splitAbjCards(cardString) {
  const cards = cardString ? String(cardString).split(",") : [];
  const andar = [];
  const bahar = [];
  cards.forEach((c, i) => {
    if (c === "1" || i <= 2) return;
    if (i % 2 !== 0) bahar.push(c);
    else andar.push(c);
  });
  return { cards, andar: andar.reverse(), bahar: bahar.reverse() };
}
